import DataQuery from 'data/DataQuery';
import IFileService from 'data/IFileService';
import { Fueling_FuelingContractsDuration, Fueling_FuelingSummaryExport } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import { CommodityDetail } from 'features/contracts/enums/commodityDetail';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import IAppState from 'infrastructure/store/IAppState';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FuelingGraphSection from './FuelingGraphSection';
import MeasuredDataHistoryHeader from 'features/shared/components/measuredData/MeasuredDataHistoryHeader';
import FuelingSummarySection from './FuelingSummarySection';
import { getRouteParams } from 'features/shared/helpers/routeParams';

type Props = {
  commodityDetail: CommodityDetail;
}

const FuelingHistorySection = ({ commodityDetail }: Props) => {
  // DI
  const fileService = useInjection<IFileService>(IocTypes.FileService);

  // store
  const customer = useSelector<IAppState, CustomerState>( (store) => store.customer).customer;

  // state
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());

  // fetch
  const contractsDurationQuery: DataQuery = {
    url: Fueling_FuelingContractsDuration,
    params: new URLSearchParams({
      CustomerId: customer.customerId!,
      CommodityDetail: commodityDetail
    })
  };
  const { data: years, loadStatus: yearsLoadStatus } = useQuery<number[]>(
    contractsDurationQuery,
    [],
    [customer.customerId]
  );

  // handlers
  const downloadMeasuredDataExcel = () => { 
    let query: DataQuery = {
      url: Fueling_FuelingSummaryExport,
      params: new URLSearchParams({
        CustomerId: customer.customerId!,
        CommodityDetail: commodityDetail
      }),
      routeParams: getRouteParams("year", String(selectedYear))
    };
    
    fileService.downloadFile(query);
   }

  // side-effects
  useEffect(() => {
    if (years.length > 0) {
      if (!years.includes(selectedYear)) {
        setSelectedYear(years[years.length - 1]);
      }
    }
  }, [years]);

  // render
  return (
    <NoContentWrapper
      data={years}
      loadStatus={yearsLoadStatus}
      noContentAsAlert
    >
      <MeasuredDataHistoryHeader 
        years={years}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        onDownloadExcelClick={downloadMeasuredDataExcel}
      />
      <FuelingGraphSection 
        entityType="Customer"
        entityId={customer.customerId!}
        commodityDetail={commodityDetail}
        from={new Date(selectedYear, 0, 1)}
        to={new Date(selectedYear, 11, 31)}
        quotationType="Month"
      />
      <FuelingSummarySection 
        year={selectedYear}
        commodityDetail={commodityDetail}
      />
    </NoContentWrapper>
  )
}

export default FuelingHistorySection;